import { get } from "@ember/object"
import _ from "lodash"

export function constructComponentStateId(component, componentId) {
  return component.toString().split("@")[1].split(":")[1] + "-" + componentId
}

export function payloadForComponent(appState, componentId, payload) {
  return _.merge({}, payload, {
    sessionId: get(appState, "id"),
    componentId: componentId,
  })
}
